<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">Ingrese su correo y contraseña</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="login()">
                    <div class="mb-3">
                      <input type="email" class="form-control"
                      placeholder="Email" name="email"
                      v-model="input.email" size="lg" />
                    </div>
                    <div class="mb-3">
                      <input type="password" class="form-control"
                      placeholder="Password" name="password" 
                      v-model="input.password" size="lg" />
                    </div>
                    <argon-switch id="rememberMe">Recordarme</argon-switch>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="dark"
                        fullWidth
                        size="lg" 
                        type="submit"
                      >Iniciar sesión</argon-button>
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    No tiene cuenta?
                    <a
                      href="javascript:;"
                      class="text-success text-gradient font-weight-bold"
                    >Sign up</a>
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background: url('/textiles.jpg'); background-size: cover;">
                <span class="mask bg-gradient-dark opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >Administrador Xhantae Shopify</h4>
                <p
                  class="text-white position-relative"
                >Administra todos los productos disponibles publicados en Shopify.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName('body')[0];

export default {
  name: "signin",
  data()  {
    return {
      input: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    login() {
      fetch('https://admin.xhantae.com/login',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: this.input.email,
          password: this.input.password
        }),
        redirect: 'follow'
      })
      .then((res) => res.json())
      .then((response) => {
        localStorage.setItem('user', JSON.stringify(response.user))
        window.location.href = 'https://admin.xhantae.com/'
      })
      .catch((error) => console.log(error))
    }
  },
  components: {
    Navbar,
    ArgonSwitch,
    ArgonButton,
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
